import React from 'react'

export const DataCatalogIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const [maskId] = React.useState(() => `mask0_${Date.now()}`)

  return (
    <svg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0)'>
        <mask
          id={maskId}
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='32'
          height='32'
        >
          <rect
            x='0.666667'
            y='0.666667'
            width='30.6667'
            height='30.6667'
            fill='#D9D9D9'
            stroke='white'
            strokeWidth='1.33333'
          />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path
            d='M16.0005 5.34961C18.9511 5.34964 21.4647 5.739 23.5415 6.51758C24.5801 6.90682 25.3578 7.33696 25.8755 7.80664C26.3929 8.27616 26.6499 8.78501 26.6499 9.33301V15.9766C26.4399 15.8997 26.2316 15.833 26.0249 15.7783C25.8147 15.7228 25.5898 15.6709 25.3501 15.6221V11.0029L25.3247 11.0186C24.2396 11.6789 22.8765 12.1933 21.2349 12.5605C19.5936 12.9278 17.8488 13.103 16.0005 13.0859C14.0786 13.0859 12.3052 12.9023 10.6812 12.5352C9.05657 12.1679 7.72107 11.6618 6.67529 11.0186L6.6499 11.0029V16.3574L6.65771 16.3623C7.70768 17.1006 9.06558 17.6551 10.731 18.0254C12.3962 18.3957 14.1531 18.5801 16.0005 18.5801H16.772C16.6268 18.7842 16.497 18.9885 16.3843 19.1943C16.2687 19.4051 16.1592 19.6333 16.0562 19.8789C14.4912 19.8749 12.848 19.7265 11.1265 19.4307C9.40177 19.1345 7.91757 18.595 6.67529 17.8135L6.6499 17.7979V22.666H6.64697L6.65283 22.6758C6.89571 23.0528 7.28263 23.4042 7.81201 23.7305C8.34149 24.0569 8.98654 24.3324 9.74658 24.5576C10.5064 24.7826 11.3713 24.9662 12.3403 25.1074C13.3057 25.2481 14.3324 25.325 15.4204 25.3408C15.4696 25.5861 15.5295 25.8145 15.6021 26.0254C15.673 26.2313 15.7476 26.4392 15.8247 26.6484C14.2982 26.6423 12.8982 26.5349 11.6255 26.3242C10.3463 26.1124 9.24093 25.8188 8.30908 25.4443C7.37718 25.0696 6.65142 24.6217 6.13037 24.1016C5.60975 23.5818 5.35014 23.0183 5.3501 22.4102V9.33301C5.3501 8.78501 5.60711 8.27616 6.12451 7.80664C6.64219 7.3369 7.41976 6.90686 8.4585 6.51758C10.5355 5.73891 13.0496 5.34961 16.0005 5.34961ZM16.0005 6.64941C14.0623 6.64941 12.1201 6.91642 10.1743 7.44922C9.20163 7.71557 8.42365 7.99426 7.84131 8.28613C7.25936 8.57783 6.87045 8.8838 6.67822 9.2041L6.67334 9.21191L6.67822 9.2207C6.86185 9.55045 7.24177 9.86606 7.81494 10.168C8.38877 10.4702 9.15835 10.7596 10.1226 11.0371C12.0514 11.5924 14.0109 11.8701 16.0005 11.8701C17.9112 11.8701 19.8374 11.6016 21.7788 11.0635C22.7494 10.7946 23.5263 10.5149 24.1079 10.2256C24.6888 9.93659 25.078 9.63665 25.271 9.32422L25.2759 9.31543L25.271 9.30664C25.0866 8.97175 24.7063 8.65249 24.1343 8.34863C23.5618 8.0446 22.795 7.75459 21.8345 7.47852C19.9127 6.9259 17.9677 6.64944 16.0005 6.64941Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.0333333'
          />
          <path
            d='M27.2578 23.6406L26.5537 24.3457L24.1367 21.9287V27.4189H23.1445V21.9287L23.1162 21.957L20.7275 24.3447L20.0234 23.6406L23.6406 20.0225L27.2578 23.6406Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.0333333'
          />
          <circle cx='23.5' cy='23.5' r='6.1' stroke='currentColor' strokeWidth='1.2' />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='32' height='32' rx='4' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
